export interface LoginRequest {
  userName: string;
  password: string;
  clientAccessIds: string[];
  employeeId?: number;
  loginType?: null;
  referenceIdent: string;
}
